import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import BankStatementTemplateFields from './BankStatementTemplateFields'

export const BankStatementTemplateCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <BankStatementTemplateFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default BankStatementTemplateCreate
